module.exports = __webpack_public_path__ + "static/media/TableSplit_After.aea6356a.jpg";